// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".job-traineeship-section[data-v-2e4e3a52]{gap:48px}.job-traineeship-section__content[data-v-2e4e3a52]{flex-basis:0;flex-grow:1;max-width:400px;min-width:300px}@media only screen and (min-width:1264px){.job-traineeship-section__content[data-v-2e4e3a52]{max-width:700px}}.job-traineeship-section__description[data-v-2e4e3a52]{color:inherit}.job-traineeship-section__slide-show[data-v-2e4e3a52]{min-width:100vw}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
